export default {
    sysTitle: "充电桩后台管理系统",
    sysMenu: "系统管理",
    currentPosition: "当前位置",
    operatorId: "运营商代码",
    oprName: "运营商名称",
    oprPkId: "运营商ID",
    tips: "提示",
    isDelete: "是否确认删除",
    deleteSuccess: "删除成功",
    updateSuccess: "修改成功",
    addSuccess: "新增成功",
    all: "全部",
    operation: "操作",
    dl: "电量",
    eleFee: "电费",
    serverFee: "服务费",
    delayFee: "延时费",
    totalAmount: "总金额",
    yuan: "元",
    kWh: "度",
    unitOrder: "单",
    ac: "交流",
    dc: "直流",
    confirm: "确认",
    noData: "暂无数据",
    allCity: "全部城市",
    chargingStation: "充电站",
    merchant: "商户",
    operator: "运营商",
    chargingPile: "充电桩",
    year: "年",
    month: "月",
    day: "日",
    timeType: "类型",
    regularText: "正常",
    irregular: "异常",
    disabled: "禁用",
    operationSucess: "操作成功",
    saveSucess: "保存成功",
    exportSuccess: "导入成功",
    allSelect: "全选",
    toExamine: "审核",
    invalid: "作废",
    remark: "备注",
    nothing: "无",
    preservation: "保存",
    recharge: "充值",
    determine: "确定",
    //单位
    unitText: {
        pen: "笔",
        yuan: "元",
        hours: "时",
        people: "人",
        seat: "座",
        wyuan: "万元",
        wkWh: "万kWh",
        wkW: "万kW",
        year: "年",
        month: "月",
        day: "日",
        ton: "吨",
        second: "次",
        full: "满",
        reduce: "减",
        give: "送",
        zhang: "张",
        individual: "个",
        minute: "分钟",
        seconds: "秒",
    },
    // form 里公用组件或者公用文字的
    formText: {
        startTime: "开始时间",
        endTime: "结束时间",
        export: "导出",
        exportLoading: "导出中...",
        exportNumber: "导出条数",
        exportPl: "导出条数不能少于等于0",
        exportError: "导出出错或者超时",
        allCity: "全部城市",
        selectGun: "充电枪",
        selectMch: "商户",
        selectSite: "充电站",
        selectPile: "充电桩",
        selectTime: "选择时间",
        selectTimePl: "请选择时间",
        selectOper: "运营商",
        downloadForm: "下载表格",
        intTips: "数值",
        beginTimeTips: "请选择开始时间",
        endTimeTips: "请选择结束时间",
        import: "导入",
        selectProvince: "请选择省",
        selectCity: "请选择市",
        selectArea: "请选择区",
        subSuccess: "操作成功",
        goBack: "返回",
        timeNull: "请选择时间",
        timeMax: "开始时间不能超过结束时间",
        time24: "近24小时",
        time7: "近7小时",
        time30: "近30小时",
        timeCustom: "自定义",
        uploadError: "请上传以下文件类型：",
        copySuccess: "复制成功",
        loginTimeOut: "登录过期,请重新登录",
        selectPl: "请选择",
    },
    directCurrent: "直流",
    alternatingCurrent: "交流",
    gunStatus: "枪口状态",
    gunStatusObj: {
        onLine: "在线",
        offLine: "离线",
        free: "空闲",
        connected: "插枪",
        charging: "充电",
        full: "充满",
        trouble: "故障",
        disabled: "禁用",
        booked: "预约",
    },
    //===========================按钮===========================
    search: "查询",
    updata: "修改",
    update: "修改",
    add: "新增",
    edit: "编辑",
    delete: "删除",
    allDel: "批量删除",
    close: "关闭",
    save: "保存",
    refresh: "刷新",
    back: "返回",
    export: "导出",
    import: "导入",
    submit: "提交",
    cancel: "取消",
    details: "详情",
    query: "查看",
    browse: "浏览",
    // 验证
    regular: {
        name: "名称",
        please: "请输入",
        pleaseSelect: "请输入",
        max: "不能超过",
        maxText: "个字符",
        min: "不能少于",
        numberABC: "只能由数字或者字母组成",
        numberABCs: "只能由数字+字母+下划线组成",
        tel: "请输入手机号码或者座机号码，7-15位",
        phone: "请输入电话",
        phonePl: "请输入手机号码",
        phonePl11: "请输入11位数字的手机号码",
        phoneError: "请输入正确格式的手机号码",
        int: "只能是整数数字",
        maxInput: "最多输入",
        minInput: "最少输入",
        unit: "位",
        maxNum: "不能大于",
        minNum: "不能小于",
        money: "金额",
        towDecimal: "最多保留两位小数",
        email: "请输入邮箱",
        emailPl: "邮箱不能超过",
        emailError: "请填写正确的邮箱",
        passwordPl: "请输入密码",
        passwordError: "密码必须包含字母和数字且长度在8-16之间，请重新输入",
    },
    //===========================云产品===========================
    // 登录
    login: {
        loginTitle: "充电桩后台管理系统",
        userName: "用户名",
        password: "密码",
        loginBtn: "登录",
        userNamePl: "请输入用户名",
        passwordPl: "请输入密码",
        passwordError: "请输入6位以上的密码",
    },
    //权限配置
    role: {
        roleList: "角色列表",
        autoMenu: "权限菜单",
        autoConfig: "配置权限",
        roleName: "角色名称",
        roleType: "角色类型",
        roleDesc: "备注",
        createUserName: "创建人",
        createTime: "创建时间",
        modifyTime: "更新时间",
        addRole: "新增角色",
        upRole: "修改角色",
        roleTypePl: "请选择角色类型",
        moduleName: "菜单模块",
        checkRender: "权限一览",
        operationUserName: "操作人",
        operationTime: "操作时间",
        operationIp: "操作IP",
        operationTypeName: "操作类型",
        content: "操作内容",
        lastOperationUserName: "最后一次操作人",
        lastOperationTime: "最后一次操作时间",
        lastOperationIp: "最后一次操作IP",
        log: "操作明细",
    },
    // 用户管理
    user: {
        globalSearch: "输入关键字搜索（用户名/角色/创建人）",
        system: "充电桩后台",
        resetPassword: "重置密码",
        userName: "用户名",
        fullName: "姓名",
        phone: "联系方式",
        objectName: "归属运营商",
        delUserConfirm: "确定删除选中的用户吗？",
        addUser: "新增用户",
        upUser: "修改用户",
        info: "基本信息",
        userPwd: "密码",
        confirmPassword: "确认密码",
        userPwdNull: "请输入密码",
        userPwdMin: "密码长度为6~18字符",
        userPwdError: "密码不能包含空格、制表符、换行符",
        userPwdTowError: "请确认新旧密码是否一致",
        queryUser: "查看用户",
        userRolePl: "请选择角色",
        newPassword: "新密码",
    },
    //日志
    log: {
        tab1: "操作日志",
        tab2: "登录日志",
        loginIp: "登录IP",
        loginTime: "登录时间",
        resultDesc: "操作详情",
        logGlobalSearch: "输入关键字搜索(用户名、登陆IP)",
        operationLogGlobalSearch: "输入关键字搜索(用户名称/模块名称/操作方法/客户端IP)",
        requestIp: "客户商IP",
        moduleName: "模块名称",
        methodDesc: "操作方法",
        operatorTime: "操作时间",
        responseCode: "操作详情",
    },
    // 在线用户
    onlineuser: {
        globalSearch: "请输入关键字(用户名/登录名/IP地址)",
        offline: "强制下线",
        offlineConfirm: "确定要强制下线吗?",
        userFullName: "角色名",
        ipAddress: "IP地址",
        loginTime: "登录时间",
    },
    // 典表
    dictionary: {
        globalSearch: "输入关键字搜索(典表名称)",
        add: "新增典表",
        updata: "修改典表",
        items: "项",
        child: "子项",
        read: "只读",
        addOp: "增删改",
        edit: "编辑",
        typeName: "典表名称",
        typePkId: "key值",
        itemList: "典表项",
        typeFlag: "典表项状态",
        typeFlagPl: "请选择典表项状态",
        remark: "备注",
        modifyTime: "更新时间",
        // 子页面
        itemsManage: "典表项管理",
        childGlobalSearch: "输入关键字搜索(典表项名称)",
        rise: "上升",
        decline: "下降",
        itemValue: "典表项名称",
        englishName: "典表项英文名称",
        itemKey: "key值",
        itemKeyPl: "请选择典表Key",
        flag: "状态",
        normal: "正常",
        disable: "停用",
    },
    // 系统升级
    systemNotice: {
        add: "新增系统升级",
        upgradeContent: "系统升级内容",
        upgradeTime: "系统升级时间",
        version: "版本",
        versionPl: "请输入版本号",
        upgradeContentPl: "请输入系统升级内容",
        upgradeTimePl: "请选择系统升级时间",
        updata: "修改系统升级",
    },
    // 模板文件
    modelFile: {
        add: "新增模板文件",
        templateFile: "模板文件",
        fileName: "文件名",
        pkid: "文件主键",
        createUserId: "创建人",
        createTime: "创建时间",
        attachmentPkId: "附件主键",
        modifyUserId: "修改人",
        modifyTime: "修改时间",
        businessType: "业务类型",
        fileType: "文件类型",
        templatePkId: "文件模板主键",
        attachmentPkIdPl: "请上传模板文件",
        businessTypePl: "请输入业务类型",
        fileNamePl: "请输入文件名称",
        fileTypePl: "请选择文件类型",
        remarkPl: "请输入备注",
        updata: "修改模板文件",
        lang: "语言",
        langPl: "请选择语言",
    },
    // 菜单
    menuList: {
        roleType: "系统",
        child: "子项",
        moduleName: "菜单名称",
        englishName: "菜单英文名称",
        privilegeVoList: "权限",
        icon: "菜单icon",
        sort: "权重",
        url: "链接",
        moduleNamePl: "请输入名称",
        englishNamePl: "请输入英文名称",
        urlPl: "请输入链接",
        addChild: "新增子菜单",
        updata: "修改子菜单",
        add: "新增菜单",
        auto: "权限选择",
        addAuto: "新增权限",
        privilegePl: "请选择权限",
    },
    //停止原因
    stopReason: {
        allConfig: "批量设置",
        add: "新增停止原因",
        stopCode: "停止代码",
        stopName: "停止原因",
        duty: "责任分配",
        addRow: "添加一行",
        updata: "修改停止原因",
        stopCodePl: "请输入停止代码",
        stopNamePl: "请输入停止名称",
        responsibilityTypePl: "请选择责任分配",
        configDataPl: "请选择要配置的数据",
        configSuccess: "配置成功",
        responsibilityType: "责任分布",
    },
    // 告警配置
    alarmSet: {
        allConfig: "批量配置",
        add: "新增告警配置",
        updata: "修改告警配置",
        alarmLevel: "告警等级",
        alarmType: "告警类型",
        faultName: "故障名",
        faultCode: "故障代码",
        faultTipMsg: "用户提示信息",
        type: "告警类型",
        addRow: "添加一行",
        faultCodePl: "请输入故障代码",
        faultTipMsgPl: "请输入用户提示信息",
        alarmLevelPl: "请选择告警等级",
        alarmTypePl: "请选择告警类型",
        configDataPl: "请选择要配置的数据",
        configSuccess: "配置成功",
        solution: "解决方法",
        solutionPl: "请输入解决方法",
        faultNamePl: "请输入故障名",
        faultEnName: "故障名英文",
        faultEnNamePl: "请输入英文名称",
        faultTipEnMsg: "用户提示信息英文",
        faultTipEnMsgPl: "请输入用户提示信息英文",
    },
    // kafka 日志
    kafkaLog: {
        globalSearch: "输入关键字搜索(主题)",
        partition: "分区",
        createTime: "创建时间",
        startOffset: "offset范围查询最小值",
        endOffset: "offset范围查询最大值",
        consumption: "重新消费",
        allConsumption: "批量重新消费",
        allConsumptionConfirm: "确定要重新消费所选中的吗?",
        allDel: "批量删除",
        allDelConfirm: "确定要删除所选中的吗?",
        topic: "主题",
        topicInfo: "消费主题信息",
        requestParam: "请求参数",
        reason: "错误信息",
    },
    // 订单校验配置
    orderConfig: {
        allOpen: "批量开启",
        allOpenConfirm: "确定要批量开启所选中的吗?",
        allClose: "批量关闭?",
        allCloseConfirm: "确定要批量关闭所选中的吗?",
        open: "已开启",
        close: "已关闭",
        enabled: "是否开启校验",
        faultName: "错误名称",
        faultCode: "错误代码",
        faultDesc: "错误简述",
        faultTypeDesc: "错误类型描述",
    },
    // 告警配置
    alarmsetting: {
        tab1: "设备告警批量设置",
        tab2: "设备告警逐条设置",
        tab3: "SIM流量告警设置",
        set: "设置",
        alarmLevel: "告警等级",
        faultCode: "故障代码",
        faultName: "故障描述",
        flow: "流量阀值",
        setLevel: "设置告警等级",
        alarmLevelName: "告警等级",
    },
    // 费率管理
    ratamanage: {
        tab1: "系统费率模板",
        tab2: "运营商费率模板",
        templateName: "模板名称",
        updateTime: "更新时间",
        jian: "尖",
        feng: "峰",
        ping: "平",
        gu: "谷",
        acRate: "交流桩充电费率（电费/服务费）",
        dcRate: "交流桩充电费率（电费/服务费）",
        delayRate: "延时费费率",
        bindStaNum: "使用数量(个)",
        modifyTime: "创建时间",
        rateDetails: "费率详情",
        delayRateDetails: "延时费费率详情",
        slotDelayPrice: "费率(元/分钟)",
        ent: "企业",
        bindSta: "关联站点",
        stationName: "站点名称",
        stationAddress: "站点地址",
        index: "序号",
    },
    //新增费率
    addRatamanage: {
        feeName: "模板名称",
        rate: "充电费率",
        delayFreeMinutes: "免费时长(分钟)",
        add: "新增系统费率模板",
        addOper: "新增运营商费率模板",
        feeNamePl: "请输入模板名称",
        acRate: "交流桩费率",
        dcRate: "直流桩费率",
        delayRate: "延时费费率",
        slotFlag: "电价类型",
        slotElecPrice: "电价(元)",
        slotServicePrice: "服务费(元/kWh)",
        timeValue: "时间段",
        pricePl: "价格请输入数字",
        priceMax: "当前价格不能超过",
        selectTimePl: "请选择时间再添加",
        timeNoSelect: "24小时已全部选择，不能再添加",
        timeError: "时间段重叠，请检查",
        timeNoSelectSuccess: "请选择完整的24小时",
        slotElecPriceMax: "电价价格不能超过",
        slotServicePriceMax: "服务费价格不能超过",
        please: "请输入",
        slotDelayPrice: "费率（元/分钟）",
    },
    // 设备型号
    equipmentModel: {
        deviceType: "设备类型",
        updateTime: "更新时间",
        globalSearch: "设备型号/生产商",
        deviceModelName: "设备型号",
        standard: "标配信息",
        matching: "选配信息",
        manufacturerName: "生产商",
        delDeviceModelName: "确定删除所选择设备型号吗？",
        minSelectItem: "请至少选择一项目",
        factoryInfo: "厂商信息",
        manufacturerPkId: "生产商名称",
        matchingAdd: "选配新增项",
        optionName: "选项名称",
        remark: "选项说明",
        addDeviceModel: "添加设备型号",
        deviceModelNamePl: "请输入设备型号",
        manufacturerPkIdPl: "请选择生产商名称",
        optionNamePl: "请输入选项名称",
        isChecked: "是否标配",
        optionValue: "固定值",
        deviceModelDetails: "设备型号详情",
        updataDeviceModel: "修改设备型号",
        optionValueError: "已勾选标配项固定值不能为空",
        deviceTypeInfo: "型号信息",
        deviceTypePl: "请选择设备类型",
        deviceModelPkIdPl: "请选择设备型号",
        optionEnName: "英文名称",
        optionEnNamePl: "请输入英文名称",
        remarkEn: "英文选项说明",
        remarkEnPl: "请输入英文选项说明",
    },
    // 新增设备型号
    addEquipmentModel: {
        typeInfo: "型号信息",
        deviceType: "设备类型",
        deviceModelName: "设备型号",
        name1: "标配",
        name2: "选配",
        manufacturerInfo: "厂商信息",
        optionalAdd: "选配新增项",
        manufacturerPkId: "生产商名称",
        optionName: "选项名称",
        remark: "选项说明",
        addDevType: "添加设备型号",
        deviceModelNamePl: "请输入设备型号",
        manufacturerPkIdPl: "请选择生产商名称",
        optionNamePl: "请输入选项名称",
        isChecked: "是否标配",
        optionValue: "固定值",
        valueNull: "值不能为空",
        valueError: "值只能是正的数值",
        detailsTitle: "设备型号详情",
        upTitle: "修改设备型号",
        addTitle: "新增设备型号",
        addSplitPile: "添加分体设备型号",
        delDevType: "删除设备型号",
        outPutRange: "输出范围",
    },
    // 设备清单
    equipmentList: {
        sns: "设备SN",
        snsPl: "sn，多个用逗号隔开",
        allSns: "批量",
        isBindOper: "配属状态",
        projectName: "归属项目",
        maintenanceMethodsType: "维护方式",
        export: "导入设备",
        add: "添加设备",
        relation: "关联",
        disassociate: "取消关联",
        disassociateConfrim: "确定要取消关联所选择的设备吗?",
        delConfirm: "确定要删除所选择的设备吗?",
        unattached: "未配属",
        attached: "已配属",
        serialNumber: "设备SN",
        gunNum: "枪口数",
        belongInfo: "配属信息",
        //导入
        import: "选择导入文件",
        importTpl: "导入模板",
        importTplDownload: "导入模板下载",
        total: "本次共计",
        dev: "台设备",
        dc: "直流桩",
        ac: "交流桩",
        protocolPkId: "协议",
        protocolPkIdPl: "请选择协议",
        //详情
        detailsTitle: "设备详情",
        dataDetails: "参数详情",
        manufacturerName: "生产厂家",
        // 关联
        typeNumber: "型号设备数量",
        changeModel: "更换型号",
        bindDev: "关联设备",
        unBindDev: "待关联设备",
        changeOper: "更换运营商",
        noChangeOper: "待更换设备",
        bindOper: "关联运营商",
        operPl: "请选择运营商",
        deviceModelPl: "请选择设备",
        //新增
        addSn: "设备SN区间",
        quantity: "数量",
        addBtn: "添加",
        snNull: "设备SN不能为空",
        snInt: "设备SN必须为数字",
        pileCommissioningDate: "投运时间",
        pileCommissioningDatePl: "请选择投运时间",
        pileProductionDate: "生产时间",
        pileProductionDatePl: "请选择生产时间",
    },
    // 设备厂商
    producer: {
        busLicenseNumber: "营业执照编号",
        brandName: "品牌名称",
        manufacturerName: "设备生产商",
        manufacturerId: "设备生产商组织机构代码",
        contactName: "联系人",
        phoneNo: "联系方式",
        legalPerson: "公司法人",
        legalIdCard: "法人身份证",
        busLicenseNumberPl: "请输入营业执照编号",
        busLicenseNumberMax: "营业执照编号长度是18位",
        brandNamePl: "请输入品牌名称",
        manufacturerNamePl: "请输入设备生产商",
        manufacturerIdPl: "请输入设备厂商组织机构代码",
        manufacturerIdMax: "营业执照编号长度是九位",
        legalPersonPl: "请输入公司法人",
        legalIdCardPl: "请输入法人身份证",
        legalIdCardMax: "法人身份证长度是十八位",
        contactNamePl: "请输入联系人",
        add: "增加设备生产商",
        updata: "修改设备生厂商",
    },
    // 运营商
    oper: {
        operData: "运营商数量",
        operTotal: "运营商总数",
        accData: "帐号到期分析",
        globalSearch: "输入关键字搜索(运营商名称/运营商简称)",
        oprStatus: "运营状态",
        expireDays: "到期日期",
        customMade: "定制",
        msgConfig: "短信配置",
        phoneConfig: "移动端配置",
        day30: "30天到期",
        day60: "60天到期",
        day90: "90天到期",
        companyName: "运营商简称",
        userName: "管理员帐号",
        deviceCount: "设备数量(台)",
        createTime: "创建时间",
        delOper: "确定删除运营商吗？",
        expireTime: "到期时间",
        //短信配置
        msgServer: "短信服务",
        agent: "短信服务商",
        pilot: "派诺",
        operMsg: "运营商自有",
        signName: "短信签名",
        "201": "充电开始通知",
        "202": "充电结束通知",
        "203": "充电结算通知",
        "301": "故障通知",
        "204": "余额不足提醒",
        "205": "发送优惠券模板",
        "101": "登录短信模版",
        "104": "身份验证模版",
        "102": "修改密码模版",
        "103": "信息变更模版",
        "105": "优惠券模版",
        agentPl: "请选择代理商",
        signNamePl: "请输入签名",
        please: "请输入",
        //新增运营商
        addOper: "运营商基础信息",
        operatorId: "组织机构代码",
        operMax: "请输入字符不能超过30个",
        companyNameMax: "10个字符以内",
        address: "详细地址",
        addressPl: "请输入详细地址",
        addressPlCity: "请选择城市",
        description: "公司描述",
        contactPerson: "联系人",
        tel: "联系电话",
        serviceTel: "客服电话",
        contactsMail: "联系人邮箱",
        oprSystemName: "运营商系统名称",
        oprSystemLogoFilePath: "系统LOGO",
        operTime: "运营期限",
        activeTime: "生效时间",
        allTime: "永久",
        add: "新增运营商",
        updata: "修改运营商",
        query: "查看运营商",
        rolePkIdPl: "请选择运营商角色",
        oprSystemLogoFilePathPl: "请上传运营商系统LOGO",
        qrCodeFilePathPl: "请上传二维码",
        mchCertFilePathPl: "请上传申请退款证书",
        logoPl: "请上传logo",
        activeTimePl: "请选择生效时间",
        zfbNamePl: "请输入短信签名",
        // 定制
        customTitle: "定制功能",
        gunQrCodeType: "充电桩枪口二维码链接",
        gunQrCodeTypePl: "请选择类型",
        gunQrCodeType1: "互联互通方式",
        gunQrCodeType2: "公众号链接方式",
        gunQrCodeTypeTextP1: "1、运营商创建后单独配置定制功能",
        gunQrCodeTypeTextP2: "2、枪口二维码默认互联互通方式，即当前的二维码模式",
        gunQrCodeTypeTextP3: "3、公众号链接方式为扫描枪口二维码带公众号链接模式",
        accTime: "账号到期分析",
        loginInfo: "运营商登录信息",
        loginUrl: "登录信息",
        loginName: "登录账号",
        loginPasswd: "登录密码",
        tips: "注：请保存好登录信息，若遗忘密码请点击重置；",
        resetPassword: "重置密码",
        close: "关闭",
        copy: "快速复制",
        loginPassword: "登录密码",
        //分成配置
        settlementTitle: "分成规则",
        settlementType: "分成规则类型",
        maxSettlementRatio: "每笔订单最大分成比例",
        settlementConfigTitle: "分成方",
        shareName: "分成方名称",
        merchantName: "收账商户名称",
        merchantPkId: "收账商户账号",
        ruleType: "分成类型",
        ruleTypeSelect2: "百分比",
        ruleTypeSelect1: "定额分成",
        base: "每笔订单",
        baseDl: "每度电分成",
        totalAmount: "总金额",
        serviceCharge: "服务费",
        settlementTypePl: "请选择分成规则类型",
        maxSettlementRatioName: "分成比例",
        amountTypePl: "请选择金额类型",
        baseName: "分成值",
        ruleTypePl: "请选择分成类型",
        removeConfirm: "确定要删除该分成方吗？",
        oprAuditStatus: "审核状态",
        splitConfig: "分成配置",
        stop: "停用",
        start: "启用",
        stopConfirm: "确定要停用运营商吗？",
        startConfirm: "确定要启用运营商吗？",
        applicationStatus: "特约商户申请状态",
        oprRegisterType: "注册方式",
        hasOpenCreditAuthority: "是否开启先充后付",
        hasOpenCreditAuthorityPl: "请选择是否开启",
        open: "开启",
        customerCode: "客户编码",
        customerCodePl: "请输入8位客户编码",
    },
    // 运营商公众号
    operWeChat: {
        title: "公众号配置信息",
        hasWeChat: "是否开启公众号",
        yes: "是",
        notifyUrl: "公众号支付域名",
        authorizeUrl: "公众号授权域名",
        menuLink: "菜单链接",
        wxInfo: "公众号信息",
        weChatLogo: "logo",
        qrCodeFilePath: "二维码上传",
        weChatName: "名称",
        primevalId: "原始ID",
        appId: "appId",
        appSecret: "secret",
        wxMchInfo: "微信商户信息",
        mchName: "商户名称",
        mchId: "商户ID",
        mchKey: "商户密钥",
        mchCertFilePath: "申请退款证书",
        download: "下载证书",
        mchCertName: "信联支付证书名称",
        mchCert: "信联支付证书存放路径",
        mchCertPwd: "商户证书密码",
        mchPosid: "商户柜台代码",
        mchBranchid: "分行代码",
        mchTxCode: "交易码",
        mchUserId: "操作员号",
        mchPassword: "操作员密码",
        ipAddr: "外联平台ip",
        port: "外联端口",
        wxPayPointsTitle: "微信支付分",
        mchCertSerialNo: "微信商户证书序列号",
        mchCertPrivateKey: "微信商户证书私钥",
        serviceIntroduction: "微信支付分服务信息",
        mchV3Key: "微信商户V3密钥",
        serviceId: "微信支付分service id",
        required: "必填项",
        appName: "应用名称",
        infoTitle: "基本信息",
        version: "版本",
        xlType: "支付版本",
        mchType: "商户类型",
        mchTypePl: "请选择商户类型",
        AppID: "App ID",
        mchPrivatePassword: "商户私钥密码",
        mchPrivateKey: "商户私钥",
        mchPrivateKeyPl: "请上传账户私钥",
        entPublicKey: "企业网关公钥",
        entPublicKeyPl: "请上传企业网关公钥",
        isSupportLedgerSplit: "是否支持分账",
        isSupportLedgerSplitPl: "请选择是否支持分账",
        zfbInfo: "支付宝支付信息",
        mchNo: "商户号",
    },
    // 小程序
    operWeChatApp: {
        title: "微信小程序配置信息",
        hasWeChat: "是否开启微信小程序",
        weChatLogoFilePath: "小程序logo",
        qrCodeFilePath: "小程序二维码",
        weChatName: "小程序名称",
        primevalId: "小程序原始ID",
        wxMchInfo: "小程序商户信息",
        wxInfo: "小程序信息录入",
    },
    //支持宝小程序
    operPay: {
        title: "支付宝小程序配置信息",
        hasZfbMini: "开启支付宝小程序",
        logo: "小程序logo",
        qrCode: "小程序二维码",
        zfbName: "支付宝应用名称",
        privateKey: "应用私钥",
        alipayPublicKey: "支付宝公钥",
    },
    //运营商账号
    operAccount: {
        reconciliation: "手动平账",
        abnormalSum: "异常数量",
        result: "对帐结果",
        accDetails: "账户详情",
        details: "对帐详情",
        formula: "对比账户",
        abnormalReason: "对比详情",
        leftAmount: "左边钱",
        rightAmount: "右边钱",
        money: "差额",
        accountType: "账户类型",
        accountPkId: "账户号",
        balanceAmount: "余额",
        orderNo: "充电订单号",
        orderNoPl: "请输入充电订单号",
        userCorrectAmount: "个人用户账户冲抵金额",
        userCorrectAmountPl: "请输入个人用户账户冲抵金额",
        prepayCorrectAmount: "托管账户冲抵金额",
        prepayCorrectAmountPl: "请输入托管账户冲抵金额",
        chargeCorrectAmount: "充电账户冲抵金额",
        chargeCorrectAmountPl: "请输入充电账户冲抵金额",
        password: "操作密码",
        passwordPl: "请输入操作密码",
    },
    // 发布通知
    postNotice: {
        globalSearch: "标题模糊检索",
        publish: "发布",
        publishConfirm: "确定要发布吗?",
        withdraw: "撤回发布",
        withdrawConfirm: "确定要撤回发布吗?",
        title: "通知标题",
        titlePl: "请输入通知标题",
        content: "通知内容",
        contentPl: "请输入通知内容",
        createTime: "创建时间",
        publishTime: "发布时间",
        publishStatus: "发布状态",
        email: "邮件通知",
        emailPl: "请选择邮件通知",
        open: "开启",
        close: "关闭",
        add: "新增发布",
        operPl: "请选择运营商",
        details: "发布详情",
        updata: "修改发布",
    },
    // 余额提醒
    balanceReminderPage: {
        triggerValue: "余额提醒",
        triggerValueTips: "账户余额低于",
        triggerValueTips2: "元后，发送通知。",
        sendWays: "通知方式",
        sendWaysTips: "公众号通知",
        triggerVTips2: "短信通知",
        wxTpl: "公众号模板检测",
        msgTpl: "短信模板检测",
        configured: "已配置",
        noConfigured: "未配置",
        noTips: "未检测到短信模板，请联系平台服务商配置",
        wxMessage: "公众号通知人员",
        msgMessage: "短信通知人员",
        phoneTips: "输入手机号多个号码用，号隔开",
        sendWaysPl: "请选择通知方式",
        phonePl: "请输入号码",
        phoneError: "号码格式错误，号码之间用 ',' 号隔开",
        phoneMax: "号码不能超过5组",
    },
    // 互联互通
    auditHlhtSystem: {
        systemnName: "系统名称",
        netDriection: "互通方向",
        netStatus: "审核状态",
        globalSearch: "关键字",
        netFileName: "下载附件",
        audit: "审核",
        auditModal: "审核互联互通",
        yes: "通过",
        no: "不通过",
        systemName: "系统名称",
        reason: "申请理由",
        netType: "互通类型",
        beginTime: "开始时间",
        endTime: "结束时间",
        contactName: "联系人",
        phoneNo: "联系方式",
        netPublic: "公开类型",
        hasOpen: "开启状态",
        oprSum: "已开通互联互通运营商数",
        netSystemSum: "互联互通数",
        netSystemSum2: "互通方向数",
        netSystemSum3: "互联互通公开类型",
        netSystemSum4: "开启状态",
        netForwardSum: "正向",
        netReverseSum: "反向",
        netBidirectionalSum: "双向",
        netInsideSum: "内部",
        netExternalSum: "外部",
        netNoSum: "开启",
        netOffSum: "关闭",
        netEndSum: "即将结束",
        accountBalance: "账户余额",
        status: "状态",
        balanceReminder: "余额提醒",
        siteOpen: "站点开放管理",
        refund: "退款",
        rapitalRecords: "资金记录",
        accountStatement: "对账单",
        pullSite: "拉取站点",
    },
    // 互联互通新增
    interflowListSend: {
        operatorId: "组织结构代码",
        projectName: "项目名称",
        systemName: "系统名称",
        protocolPkId: "协议主键",
        phoneNo: "联系方式",
        contactName: "联系人",
        netDriection: "互通方向",
        netType: "互通类型",
        beginTime: "互联开始日期",
        endTime: "互联结束日期",
        netFileUrl: "附件",
        upload: "上传文件",
        reason: "申请理由",
        tab1: "基本信息",
        tab2: "平台密钥",
        tab3: "运营商密钥",
        addInterflow: "新增互联互通",
        reasonPl: "请输入申请理由",
        netDriectionPl: "请选择互通方向",
        netTypePl: "请选择互通类型",
        beginTimePl: "请选择开始时间",
        endTimePl: "请选择结束时间",
        netFileUrlPl: "请上传附件",
        protocolPkIdPl: "请输入协议主键",
        upInterflow: "修改互联互通",
        detailsInterflow: "互联互通详情",
        aesDataSecret: "数据加密密钥",
        aesDataSecretIV: "初始化向量",
        operatorSecret: "运营商密钥",
        sigSecret: "签名密钥",
        requestUrl: "请求平台地址",
        rechargeAmount: "充值金额(元)",
        rechargeSuccess: "充值成功",
        refundAmount: "退款金额(元)",
        refundBtn: "退款",
        refundError: "退款金额不能超过账户余额",
        refundSuccess: "退款成功",
        refundOrderNo: "订单号",
        balance: "账户余额",
    },
    // 互联互通-- 资金记录
    interflowRecord: {
        tab1: "充电记录",
        tab2: "充值记录",
        tab3: "退款",
        accountPkId: "账户号",
        modelTitle: "资金记录",
    },
    // 互联互通-- 对账单
    interflowBill: {
        abnormal: "推送结果",
        queryDetails: "明细",
        errorOrder: "异常订单",
        normal: "正常",
        error: "异常",
        beginTime: "账单开始时间",
        endTime: "账单结束时间",
        orderNumber: "订单数(笔)",
        totalChargeElect: "总电量(kWh)",
        totalAmount: "总金额(元)",
        abnormalNumber: "异常订单数(笔)",
        abnormalAmount: "异常订单金额(元)",
        checkingResult: "核对结果",
        reset: "重置",
        diffContent: "争议原因",
        tab1: "对账单",
        tab2: "对账单明细",
    },
    //增值服务
    addValueService: {
        serviceName: "服务名称",
        logo: "服务logo",
        hasOpen: "开放状态",
        add: "新增增值服务",
        enable: "启用",
        disabled: "禁用",
        logoPl: "请上传文件",
        hasOpenPl: "请选择状态",
    },
    //参数配置
    dataConfig: {
        tab1: "电费配置",
        tab2: "二维码配置",
        connectLoading: "连接通迅中.....",
        connectClose: "连接中断或者连接已关闭",
        reconnect: "重新连接",
        realTimeMsg: "实时报文",
        clear: "清除",
        gunPkIdPl: "请选择枪口",
        subscribeSuccess: "订阅成功",
        pilePkId: "桩编号",
        pilePkIdPl: "请选择桩",
        gunPkId: "枪编号",
        ratedVoltage: "额定电压",
        ratedCurrent: "额定电流",
        ratedPower: "设备功率",
        // 报文
        reply: "回复",
        get: "请求",
        pile: "桩",
        platform: "平台",
        pileData: "桩 数据",
        platformData: "平台 数据",
        // 二维码
        rateName: "二维码",
        rateNamePl: "请输入二维码字符串",
        getBtn: "召测",
        issue: "下发二维码",
        send: "发送",
        clickSend: "点击发送",
        response: "响应",
        issueSuccess: "下发成功",
        //电费配置
        ratePkid: "费率",
        rateTpl: "费率模板名称",
        acRate: "交流桩费率",
        pileRate: "桩费率",
        platformRate: "平台费率",
        slotFlag: "电价类型",
        slotElecPrice: "电价(元/kWh)",
        slotServicePrice: "服务费(元/kWh)",
        time: "时间段",
    },
    // 充电操作
    chargingOperation: {
        status1: "空闲",
        status2: "已插枪",
        status3: "启动充电",
        status4: "充电中",
        status5: "等拔枪",
        tab1: "充电上报数据",
        tab2: "BMS上报数据",
        tab3: "充电报告数据",
        startCharging: "启动充电",
        msgType1: "实时",
        msgType2: "历史",
        time: "通讯时间",
        loadMore: "加载更多",
    },
    // 运维数据
    operData: {
        tab1: "设备登录",
        tab2: "设备心跳",
        tab3: "故障上报",
        tab4: "升级",
        upgrade: "升级",
        202: "升级包版本",
        1009: "最大充电功率",
        1007: "最大充电电流",
        513: "SIM卡ICCID",
        1003: "禁止/允许离线充电",
        2024: "SIM卡信号强度",
        100: "联网方式",
        1010: "二维码",
        58: "复费率单价版本号",
        sendSuccess: "指令已发送，看看设备状态吧",
        allow: "允许",
        prohibit: "禁止",
        ethernet: "以太网",
        host: "主机Ip地址",
        port: "主机端口",
        userName: "FTP用户名",
        password: "FTP用户密码",
        fileDir: "文件目录",
        success: "升级成功",
    },
    // 短信管理
    messageManage: {
        msgTitle: "短信池",
        rechange: "充值",
        remaining: "剩余可用条数(条)",
        used: "已用条数(条)",
        top5: "剩余可用条数top5",
        unit: "条",
        remainingMin: "剩余条数最小值",
        remainingMax: "剩余条数最大值",
        usedMin: "已用条数最小值",
        usedMax: "已用条数最大值",
        recordBtn: "短信记录",
        rechargeBtn: "短信充值",
        totalNum: "已购买条数",
        sentNum: "已用条数",
        addNum: "增加条数",
        remainNum: "剩余条数",
        comboPkId: "购买条数",
        paymentAmount: "支付金额",
        msgRechange: "短信充值",
        comboPkIdPl: "请选择短信条数",
    },
    // 短信记录
    messageRecord: {
        tab1: "购买记录",
        tab2: "发送记录",
        pkid: "订单号",
        purchasedWay: "购买方式",
        auditStatus: "订单状态",
        attachmentUrl: "附件",
        downloadAttachmentUrl: "下载附件",
        audit: "审核",
        createUserName: "操作人员",
        purchasedCount: "购买条数",
        paymentAmount: "支付金额",
        createTime: "购买时间",
        phoneNo: "手机号码",
        agent: "发送类型",
        bussType: "业务类型",
        pilot: "派诺",
        aliCloud: "阿里云",
        sendTime: "发送时间",
        content: "发送内容",
        status: "发送状态",
        auditAction: "审核状态",
        oprSystemLogoFilePath: "上传附件",
        msgAudit: "短信审核",
        auditActionPl: "请选择审核状态",
        oprSystemLogoFilePathPl: "请上传附件",
        auditAction1: "通过",
        auditAction2: "拒绝",
        payMethod: "支付方式",
        invoiceStatus: "开票状态",
        contractAudit: "合同审核",
        payAudit: "支付审核",
        invoiceAudit: "发票审核",
        invoicing: "发票已开具",
        needContract: "是否需要合同",
        contractYes: "需要",
        contractNo: "不需要",
        orderInfo: "订单信息",
        packageInfo: "套餐信息",
        auditInfo: "审核信息",
        auditComment: "审核意见",
        auditYes: "审核通过",
        auditNo: "审核不通过",
        remarkPl: "请输入审核意见",
        orderStatus: "订单状态",
        orderAmount: "订单金额",
        packagePrice: "套餐价格",
        remark: "备注",
        invoiceInfo: "发票信息",
        auditRecord: "审核记录",
        payTime: "支付时间",
        contractNetFileUrl: "购买合同",
        paymentNetFileUrl: "支付凭证",
        rechargeTime: "充值时间",
        beforeSmsCount: "充值前短信条数",
        afterSmsCount: "充值后短信条数",
        invoiceYes: "同意",
        invoiceNo: "拒绝",
        invoiceRemark: "拒绝原因",
        invoiceRemarkPl: "请输入拒绝原因",
        contractStatus: "合同状态",
        paymentStatus: "支付状态",
        paymentVoucherStatus: "支付审核状态",
    },
    // 短信定价
    messagePrice: {
        number: "短信条数",
        price: "套餐价格",
        contactPhone: "联系人手机号",
        status: "状态",
        rechargeContact: "充值联系人",
        rechargeTips: "修改联系人信息将同步修改其它短信条数套餐联系信息，请谨慎修改",
        qrCodeFilePkId: "联系人微信",
        qrCodeFilePkIdTips: "上传二维码,支持.jpg .jpeg .png",
        qrCodeFilePkIdPl: "请上传联系人微信",
        updata: "修改定价",
        add: "新增定价",
        close: "关闭",
        closeConfirm: "确定要关闭吗?",
    },
    // license管理
    cardClient: {
        projectName: "项目名称",
        updataTime: "更新时间",
        queryCode: "查看客户编码",
        licenseBtn: "Licence管理",
        createUserName: "创建人",
        activatedAmount: "已激活条数",
        projectCode: "客户编码",
        modifyTime: "下载Licence文件",
        moduleNames: "Licence模块",
        machineCode: "序列号",
        pileNumber: "桩数",
        status: "状态",
        beginTime: "生效日期",
        endTime: "到期日期",
        add: "新增项目",
        projectNamePl: "请输入项目名称",
        projectCodeMax: "客户编码必须是8位数字",
        modulePkIdsPl: "请选择Licence模块",
        machineCodePl: "请输入序列号",
        beginTimePl: "请选择生效日期",
        endTimePl: "请选择到期日期",
        addLicence: "新增Licence",
        updataLicence: "修改Licence",
        timeMax: "生效日期不能超过到期日期",
    },
    // SIM卡管理
    simOutTest: {
        projectName: "项目名称",
        keywords: "关键字",
        pileNoOrIccidPl: "设备编号/ICCID",
        applicantOrCaller: "申领人/召测人",
        simStatus: "SIM卡状态",
        createTime: "创建时间",
        recallTest: "SIM卡召测",
        claim: "SIM卡申领",
        batchSync: "批量同步",
        sync: "同步",
        applicant: "申领人",
        caller: "召测人",
        outgoer: "出库人",
        modifyTime: "更新时间",
        simStatusPl: "请选择SIM卡状态",
        serialNumber: "设备编号",
        applyTitle: "申领SIM卡",
        iccid: "SIM卡编号",
        iccidTips: "请输入，限100字",
        importFile: "导入文件",
        downloadTpl: "下载模板",
        simSum: "SIM卡数量",
        applicantPl: "请输入申领人",
        iccidPl: "请输入SIM卡编号",
        outgoerPl: "请输入出库人",
        snStartNo: "输入开始编号",
        snEndNo: "输入结束编号",
        match: "匹配",
        projectNamePkId: "关联项目",
        saveExport: "保存并导出",
        modalTitle: "SIM卡召测",
    },
    // 生产任务单
    productionOrder: {
        step0: "流程开始",
        step1: "第一步",
        step2: "第二步",
        step3: "第三步",
        step4: "流程结束",
        content0: "新增任务单",
        content1: "开始生产",
        content2: "设备入库",
        content3: "品质核检",
        content4: "设备发货",
        keyword: "关键字",
        numOrProject: "合同单号/项目名称",
        modelName: "设备型号",
        productionStatus: "生产状态",
        createTime: "创建日期",
        syncDev: "同步设备",
        start: "开始生产",
        void: "作废",
        changePriority: "调整优先级",
        warehousing: "设备入库",
        check: "品质核捡",
        ship: "设备发货",
        index: "序号",
        priority: "优先级",
        orderType: "任务单类型",
        contractBillNumber: "合同单号",
        projectName: "项目名称",
        platformModel: "平台型号",
        pileNum: "设备数量",
        doneModelNum: "已发货数",
        warehousingConfirm: "确定要入库吗?",
        delConfirm: "确定要删除该生产单吗?",
        voidConfirm: "确定要作废该生产单吗?",
        startConfirm: "确定要开始生产吗?",
        //新增
        projectInfo: "项目信息",
        contractBillNumberPl: "请选择合同单号",
        priorityPl: "请选择优先级",
        projectNamePl: "请选择项目名称",
        devInfo: "设备信息",
        materialNumber: "成品物料编码",
        materialNumberPl: "请输入成品物料编码",
        clientNum: "客户编码",
        clientNumPl: "请输入客户编码",
        deviceModelPkId: "设备型号",
        deviceModelPkIdPl: "请选择设备型号",
        platformModelPl: "请选择平台型号",
        deviceNo: "设备编号",
        deviceStartNo: "开始设备编号",
        deviceEndNo: "结束设备编号",
        quantity: "设备数量",
        motherboard: "主板",
        motherboardPl: "请输入主板",
        interfaceBoard: "接口版",
        interfaceBoardPl: "请输入接口版",
        displayScreen: "显示屏",
        displayScreenPl: "请输入显示屏",
        requirements: "定制和生产要求",
        requirementsPl: "请输入定制和生产要求",
        inputMaxPl: "请输入，限100字",
        equipmentRemarks: "设备备注",
        equipmentRemarksPl: "请输入设备备注",
        adds: "继续添加",
        issuerAndCard: "发卡器+IC卡",
        issuerAndCardPl: "请输入发卡器+IC卡",
        remark: "任务单备注",
        remarkPl: "请输入任务备注",
        verificationInfo: "核检信息",
        verifier: "核检人",
        checkContent: "核检内容",
        shippingInfo: "出货信息",
        deliveryRequirements: "发货要求",
        logisticsAndNumber: "物流及单号",
        inspectionAndSignature: "巡检及出货检签名",
        shippingCardIssuerICCard: "发卡器+IC卡",
        shippingCardIssuerICCardPl: "请输入发卡器+IC卡",
        orderTypePl: "请选择任务单类型",
        add: "新增任务单",
        updata: "修改任务单",
        details: "任务单详情",
        other: "其他信息",
        deliveryRequirementsPl: "请输入发货要求",
        logisticsAndNumberPl: "请输入物流及单号",
        inspectionAndSignaturePl: "请输入巡检及出货检签名",
        verifierPl: "请输入核检人",
        checkContentPl: "请输入核检内容",
    },
    //销售订单
    salesOrder: {
        globalSearch: "合同单号/项目名称/销售员",
        sellerName: "销售员",
        specificationModel: "规格型号",
        month: "预计发货",
        monthPl: "请选择预计发货",
        deliveryTime: "发货时间",
        shipConfirm: "确定要发货吗?",
        childTitle: "子项目-产品信息",
        number: "数量",
        requirementDesc: "需求描述",
        requirementDescPl: "请输入需求描述",
        shippingAddress: "发货地址",
        shippingAddressPl: "请输入发货地址",
        add: "新增销售订单",
        contractBillNumberPl: "请输入合同单号",
        specificationDetails: "请输入规格型号",
        specificationDetailsPl: "请输入规格型号",
        sellerNamePl: "请输入销售员",
        month1: "一月",
        month2: "二月",
        month3: "三月",
        month4: "四月",
        month5: "五月",
        month6: "六月",
        month7: "七月",
        month8: "八月",
        month9: "九月",
        month10: "十月",
        month11: "十一月",
        month12: "十二月",
    },
    // 头部
    header: {
        clickGo: "点击跳转",
        out: "退出登录",
        outConfirm: "确定要退出登录吗？",
        unit: "条",
    },
    // 设备档案
    reportFile: {
        pageTitle: "报告档案",
        deviceArchivePkId: "档案ID",
        deviceTypeName: "设备类型",
        manufacturerName: "生产厂商",
        deviceModelName: "设备型号",
        deviceModelRatedPower: "额定功率",
        deviceModelChargeStandardName: "设备标准",
        archiveCode: "报告编号",
        feelerMechanismName: "测试机构",
        archiveCreateDate: "报告生成日期",
        attachmentRecordPkId: "型式试验报告",
        entryDate: "录入日期",
        deviceRatedPower: "功率范围(kW)",
        query: "点击查看",
        change: "更换报告",
        updataTitle: "请选择文件",
        minDeviceRatedPowerError: "功率范围最小值不能小于0",
        maxDeviceRatedPowerError: "功率范围最大值不能小于0",
        minMaxDeviceRatedPowerError: "功率范围最大值不能小于最小值",
    },
    // 站点规模配置
    siteSizeConfig: {
        smallSizeStaNum: "小规模",
        mediumSizeStaNum: "中规模",
        largeSizeStatNum: "大规模",
        configName: "配置名称",
        pileNum: "桩数量（台）",
        power: "功率（kw）",
        min: "小于",
        max: "大于",
        updataTitle: "修改站点规模配置",
        maxTips: "最大值不能小于最小值:",
        maxPile: "桩最大值",
        minPile: "桩最小值",
        maxPower: "功率最大值",
        minPower: "功率最小值",
    },
    //站点开放管理
    bindSites: {
        rateSet: "站点费率设置",
        dcElecFee: "直流桩电价",
        acElecFee: "交流桩电价",
        dcServiceFee: "直流桩服务费",
        acServiceFee: "交流桩服务费",
        hasOriginalFee: "原价",
        yes: "是",
        beginTime: "开始时间",
        endTime: "结束时间",
        bindSite: "关联站点",
        self: "自营",
        unself: "非自营",
        amount: "金额",
        please: "请输入",
        pleaseCorrect: "请输入正确的",
        towNumber: "，最多保留两位小数",
        max: "不能大于",
        delayFeeTypePl: "请选择占桩费优惠方式",
        serviceFeeTypePl: "请选择服务费优惠方式",
        elecFeeTypePl: "请选择电费优惠方式",
    },
    // 共用名称（订单列表也在里面）
    commonTableName: {
        no: "否",
        yes: "是",
        open: "已开启",
        close: "已关闭",
        insideOrderNo: "内部订单号",
        externalOrderNo: "外部订单号",
        orderStatus: "订单状态",
        orderType: "订单类型",
        details: "详情",
        endOrder: "结束订单",
        error: "异常处理",
        orderNo: "订单号",
        merchantName: "商户名称",
        netSystemName: "互联运营商",
        orderStatusDesc: "订单状态",
        staName: "站点名称",
        pileName: "桩名称",
        gunName: "枪名称",
        serialNumber: "桩编号",
        memberName: "会员名",
        phoneNo: "手机号",
        carNo: "车牌号",
        chargeBeginTime: "开始充电时间",
        chargeEndTime: "结束充电时间",
        payTime: "支付时间",
        chargeDuration: "充电时长",
        delayDuration: "占桩时长",
        chargeElect: "电量(kWh)",
        chargeAmount: "电费(元)",
        serviceAmount: "服务费(元)",
        time: "时间段",
        delayAmount: "占桩费(元)",
        totalAmount: "消费总金额(元)",
        discountAmount: "优惠总金额",
        transactionAmount: "实付金额（元）",
        startSoc: "开始soc",
        endSoc: "结束soc",
        stopReason: "停止原因",
        orderSource: "订单来源",
        abnormalType: "是否异常",
        elecPrice: "电费费率(元/kWh)",
        servicePrice: "服务费率(元/kWh)",
        slotFlag: "电价类型",
        slotElecPrice: "电价(元)",
        delayMins: "时长(分钟)",
        delayFreeMins: "免费时长(分钟)",
        sex: "性别",
        vipType: "会员类型",
        vipLevel: "会员等级",
        vin: "VIN码",
        cardType: "车型",
        staType: "站点类型",
        staStatus: "站点状态",
        staAddr: "充电站地址",
        gunPkId: "枪编号",
        manufacturer: "归属厂商",
        deviceType: "电桩类型",
        devicemodel: "设备型号",
        ratedPower: "额定功率",
        ratedCurrent: "额定电流",
        ratedVoltage: "额定电压",
        timeInterval: "时段",
        chargeDiscount: "电费优惠",
        serviceDiscount: "服务费优惠",
        delayDiscount: "占桩费优惠",
        totalDiscount: "优惠总金额",
        chargeTransAmount: "实付电费（元）",
        serviceTransAmount: "实付服务费（元）",
        jian: "尖",
        feng: "峰",
        ping: "平",
        gu: "谷",
        beforeBalance: "消费前金额(元)",
        afterBalance: "消费后金额(元)",
        reteInfo: "电桩费率信息",
        charge: "充电次数(次)",
        startTime: "开始时间",
        endTime: "结束时间",
        modifyTime: "更新时间",
        staPkId: "站点编号",
        entUserName: "企业会员",
        chargingCard: "用户卡号",
        consumptionPattern: "充电模式",
        chargingMode: "充电方式",
        userType: "用户类型",
    },
    //账户充值
    accountRecharge: {
        auditMoney: "审核中充值金额(元)",
        accountMaxTips: "账户余额最高为",
        rechargeMaxTips: "单笔充值金额最高不能超过",
        rechargeAmount: "充值金额(元)",
        accountMaxError: "当前账户余额及待审核金额总和已超过最高限额，暂无法充值",
        rechargeMax: "当前最多可充值",
        rechargeSuccessTips: "请等待审核，充值金额审核通过后即刻到账",
        rechargeSuccess: "充值完成",
    },
    //账户充值-- 资金记录
    accountRechargeRecord: {
        transactionTime: "充值时间",
        rechargeAmount: "充值金额（元）",
        beforeBalance: "充值前余额（元）",
        afterBalance: "充值后余额（元）",
    },
    //账户退款-- 资金记录退款
    accountRefundRecord: {
        transactionTime: "申请退款时间",
        refundAmount: "申请退款金额（元）",
        refundedAmount: "成功退款余额（元）",
        orderStatusDesc: "订单状态",
        transactionAmount: "退款总金额（元）",
        wxTransAmount: "微信退款金额（元）",
        alipayTransAmount: "支付宝退款金额（元）",
        cashTransAmount: "现金退款金额（元）",
        accountBalance: "当前总余额（元）",
        refundMethod: "退款渠道",
        exportName: "退款记录",
    },
    // 城市操作页面
    cityConfig: {
        name: "区域名称",
        regionLevel: "级别",
        regionLevel1: "省",
        regionLevel2: "市",
        regionLevel3: "区",
        mergerName: "全称",
        pinyin: "区域拼音",
        cityCode: "城市编码",
        shortName: "编码",
        zipCode: "邮编",
        pkid: "行政区划代码",
        lng: "经度",
        lat: "维度",
        lngLat: "经维度",
        addRow: "添加",
        modalTitle: "省市区改动",
        pkidPl: "请输入行政区划代码",
        namePl: "请输入名称",
        pinyinPl: "请输入区域拼音",
        lngPl: "请输入经维度",
        lngMax: "经维度值不能大于1000",
        lngLenMax: "经维度小数不能大于6位",
    },
    modalShowMap: {
        showMap: "开启地图",
        addrPl: "请输入地址",
        noData: "暂无数据",
    },
    //发票管理
    invoiceInfo: {
        applicationTime: "申请时间",
        globalSearch: "订单号/手机号",
        invoiceType: "发票类型",
        invoicingStatus: "开票状态",
        auditSettings: "审核设置",
        invoiceOrderNumber: "发票订单号",
        invoiceHeaderType: "抬头类型",
        invoiceTitle: "发票抬头",
        taxNumber: "税号",
        invoiceAmount: "开票金额(元)",
        phoneNumber: "手机号",
        invoicing: "开票",
        invoiceUserName: "开票用户",
        issuer: "开票人",
        processingMethod: "处理方式",
        courierCompany: "快递公司",
        shipmentNumber: "物流单号",
        remark: "备注",
        haveBeenMailed: "邮寄",
        noNeedToMail: "无需邮寄",
        enterIssuer: "请输入开票人",
        selectMethod: "请选择开票方式",
        validationError: "表单验证错误",
        selectAddress: "请输入邮寄地址",
        enterNumber: "请输入邮寄订单号",
        orderNumberLength: "邮寄订单号长度不得小于八位",
        invoiceSuccessful: "开票成功",
        numberOfInvoices: "已开票数量（张）",
        electronicInvoice: "电子发票",
        paperInvoice: "纸质发票",
        totalInvoicedAmount: "已开票总金额（元）",
        invoicedServiceFee: "已开票服务费（元）",
        invoicedElectricityBill: "已开票电费（元）",
        invoiceReviewProcess: "发票审核流程",
        on: "开启",
        close: "关闭",
        selectionProcess: "请选择发票审核流程",
        setSuccessfully: "设置成功",
        invoiceInformation: "发票信息",
        serviceCharge: "服务费(元)",
        electricityBill: "电费(元)",
        eMail: "电子邮箱",
        receivingInformation: "接收信息",
        invoicingInformation: "开票信息",
        processingTime: "处理时间",
        invoiceSerialNumber: "发票流水号",
        payee: "收款人",
        reviewer: "复核人",
        unit: "单位",
        invoicePicture: "发票图片",
        shippingAddress: "收件地址",
        denialReason: "请输入拒绝原因",
        orderNumber: "订单号",
        delayFee: "占桩费（元）",
        discountedPrice: "优惠金额（元）",
        amountActuallyPaid: "实付金额（元）",
        reviewCompleted: "审核完毕",
        invoiceOperator: "发票运营商",
        invoiceOrder: "发票订单",
        invoiceAuditRecord: "审核记录",
        operationTime: "操作时间",
        operationStatus: "处理动作",
        operation: "处理人",
        applyStatuse: "当前状态",
        confirmAudit: "确定要审核通过吗?",
        operationSys: "系统自动处理",
        registerAddress: "注册地址",
        registerTelephone: "注册电话",
        bankDeposit: "开户银行",
        bankAccountNo: "银行账户",
        requestInvoiceType: "申请类型",
        requestInvoiceTypeSelect1: "充电发票",
        requestInvoiceTypeSelect2: "短信充值发票",
    },
    //短信配置
    messageConfig: {
        tab1: "合同配置",
        tab2: "支付方式",
        tab3: "余量提醒",
        tab4: "注册配置",
        contractConfig: "合同配置",
        needContract: "购买是否需要合同",
        attachmentPkId: "购买合同模板",
        attachmentPkIdPl: "请上传文件",
        transfer: "对公转账",
        bankAccountName: "开户名",
        bankDeposit: "开户银行",
        bankAccountNo: "银行账户",
        wxPay: "微信支付",
        appId: "公众号appid",
        mchId: "商户号",
        mchName: "商户名称",
        mchKey: "商户密钥",
        notifyUrl: "异步通知接口",
        bankAccountNamePl: "请输入收款账户名",
        bankAccountNoPl: "请输入收款银行账户",
        bankDepositPl: "请输入账户开户银行",
        appIdPl: "请输入appId",
        mchIdPl: "请输入微信商户号",
        mchKeyPl: "请输入微信商户密钥",
        mchNamePl: "请输入商户名称",
        notifyUrlPl: "请输入异步通知接口",
        reminder: "余量提醒",
        onOff: "是否开启",
        smsReminderValue: "提醒阈值",
        smsReminderValueMinTips: "剩余短信条数低于",
        smsReminderValueMinTips2: "条后，发送通知",
        configRegister: "注册发送短信运营商",
        operPl: "请选择运营商",
    },
    // 短信发票
    msgApplyInvoice: {
        hasDefault: "默认",
        setHasDefault: "设为默认",
        ent: "企业单位",
        entNo: "个人/非企业",
        info: "接收信息",
        sendEmail: "电子邮件",
        phoneNo: "手机号",
        addressee: "收件人",
        mailingAddress: "收件地址",
        sublimt: "提交申请",
        addresseePl: "请输入收件人",
        mailingAddressPl: "请输入收件地址",
        invoiceTitleInfo: "抬头信息",
        invoiceTitleType: "发票类型",
        invoiceTitle: "抬头名称",
        taxId: "税号",
        registerTelephone: "注册电话",
        registerAddress: "注册地址",
        hasDefaultSelect: "是否默认",
        invoiceAccount: "开票金额",
        applyStatus: "开票状态",
    },
    // 服务商配置
    serviceProvider: {
        tab1: "微信公众号",
        tab2: "微信小程序",
        tab3: "服务商信息",
    },
    // 导入模板
    importModal: {
        importTemplate: "导入模板",
        downloadTemplate: "下载模板",
        selectFile: "选择文件",
    },
    //SIM卡管理
    simManage: {
        allTestBtn: "批量召测",
        testBtn: "召测",
        allChangeBtn: "批量变更",
        changeBtn: "变更",
        allRenewBtn: "批量续费",
        renewBtn: "续费",
        changeRecord: "变更记录",
        renewalRecord: "续费记录",
        staNum: "站点总数",
        pileNum: "设备总数",
        successNum: "已召回数",
        toBeActivatedNum: "待激活数",
        activatedNum: "已激活数",
        closedNum: "停机数",
        testableNum: "可测试数",
        inventoryNum: "库存数",
        closeSoonNum: "预销户数",
        dueSoonNum: "即将到期数",
        preCloseNum: "即将销户数",
        testBtnConfirm: "确定对该运营商进行召测",
        allTestBtnConfirm: "确定对已选运营商进行召测",
        allTestBtnConfirmTips: "由于设备较多召测时间可能过长，请稍后查看召测结果",
        successNumSta: "SIM卡已召回数",
        dueSoonNumSta: "即将到期的SIM卡数",
        closeSoonNumSta: "即将销户的SIM卡数",
        noCallNum: "未召回数",
        importNum: "导入数",
        matchNum: "匹配数",
        use4gNum: "4g数",
        networkNum: "以太网数",
        wifiNum: "WiFi数",
        unknownNum: "未知数",
        callNum: "已召回数",
        other: "其它",
        changType: "变更操作",
        changType1: "复机",
        changType0: "停机",
        stopReason: "停机原因",
        stopReasonPl: "请输入停机原因，不超过50个字符",
        stopReasonPlRule: "请输入停机原因",
        iccidTitle: "确定对已选SIM卡进行变更",
        iccidTitleAll: "批量变更：确定对已选SIM卡进行批量变更",
        oprTitle: "确定对已选运营商进行变更",
        oprTitleAll: "批量变更：确定对已选运营商进行批量变更",
        renewalDate: "续费日期",
        endDateType: "截止日期",
        endDateType0: "固定日期",
        endDateType1: "续费延长时间",
        endDateTypePl: "请选择截止日期",
        renewalTimePl: "请选择日期",
        renewIccidTitle: "确定对已选SIM卡进行续费",
        renewIccidTitleAll: "批量续费：确定对已选SIM卡进行批量续费",
        renewOprTitle: "确定对已选运营商进行续费",
        renewOprTitleAll: "批量续费：确定对已选运营商进行批量续费",
        renewalDateMaxError: "续费日期不能大于截止日期",
    },
    // SIM卡管理
    systemSim: {
        status: "SIM卡状态",
        activeDate: "激活日期",
        endDate: "截止日期",
        renewalDate: "续费日期",
        closingDate: "销户日期",
        hasBindOpr: "关联运营商",
        hasRemark: "备注状态",
        changeAllOpenBtn: "批量复机",
        changeAllStopBtn: "批量停机",
        changeOpenBtn: "复机",
        changeStopBtn: "停机",
        remarkAllBtn: "批量备注",
        remarkBtn: "备注",
        testBtnConfirm: "确定对该SIM卡进行召测",
        allTestBtnConfirm: "确定对已选SIM卡进行召测",
        stopReason: "停机原因",
        networkingMode: "联网方式",
        dataFrom: "获取方式",
        remarkOperate: "备注操作",
        remarkPl: "请输入备注信息",
        remarkOpen: "开启备注",
        remarkColse: "关闭备注",
        allRemark: "批量备注",
        remarkNum: "备注数",
        totalNum: "SIM卡总数",
    },
    // 变更记录
    simChangeRecord: {
        changeDate: "变更日期",
        stopReason: "停机原因",
        stopReasonRemark: "停机备注",
        operateState: "操作状态",
        failReason: "失败原因",
        createUserName: "变更人",
        createUserId: "操作人",
    },
    // 电池检测
    batteryTest: {
        orderNo: "充电订单号",
        acquired: "用户状态",
        userName: "用户名称",
        userPhone: "用户手机号",
        detailsBtn: "报告详情",
        acquiredStatus: "用户状态",
        carBatteryInfo: "车辆及充电信息",
        carInfo: "车辆信息",
        chargeInfo: "充电信息",
        carNo: "车牌号",
        libMaf: "电池厂商",
        brand: "车辆品牌",
        libType: "电池类型",
        model: "车辆型号",
        libBday: "电池生产日期",
        stdQ: "整车额定容量",
        stdV: "整车额定总电压",
        chaE: "本次充电量",
        startTime: "充电开始时间",
        chaTime: "本次充电时长",
        endTime: "充电结束时间",
        dsoc: "SOC增长",
        carbon: "本次节省碳排放量",
        batteryAnalysis: "电池健康分析",
        socSta: "SOC状态",
        trateMax: "最大温升速率",
        cellVSta: "单体电压状态",
        tempAve: "平均充电温度",
        tsta: "温度状态",
        socStart: "本次开始SOC",
        rsta: "绝缘状态",
        socEnd: "本次结束SOC",
        conSta: "动力链接状态",
        powerAve: "平均功率",
        healthScore: "综合健康评分",
        score: "分",
    },
    siteTag: {
        tagName: "标签名称",
        boundStaNum: "关联站点数",
        createTime: "创建时间",
        bindSite: "关联站点",
        addTag: "添加标签",
    },
    //服务商信息
    operInfo: {
        feedbackFunction: "反馈功能开启",
        operName: "服务商",
        contactPerson: "联系人",
        contactPhone: "联系电话",
        action: "操作",
        config: "配置",
        contactWechat: "联系人微信",
        operInfoConfig: "服务商信息配置",
        contactWechatCode: "联系人微信二维码",
        upload: "上传",
        confirm: "确定",
        cancle: "取消",
        operNamePl: "请输入服务商名称",
        contactPersonPl: "请输入联系人姓名",
        contactPhonePl: "请输入联系人电话",
        cannotOpen: "无法开启",
        openTip1: "暂无法开启该功能",
        openTip2: "需要先对服务商信息进行配置",
        qrCode: "二维码",
        problemType: "问题类型",
        operHasRead: "是否已读",
        operHasReply: "是否回复",
        addFeedback: "新增反馈",
        feedbackTime: "反馈时间",
        feedbackPerson: "反馈人",
        problemContent: "问题内容",
        replyTime: "回复时间",
        addProblem: "新增问题",
        checkReply: "查看回复",
        operReply: "服务商回复",
        replyContent: "回复内容",
        yes: "是",
        no: "否",
        replyPerson: "回复人",
        replyFeedback: "回复反馈",
        operatorReply: "服务商回复",
        checkFeedback: "查看反馈",
        replySuccess: "回复成功",
    },
};
